import React from 'react'
import style from './style.module.scss'

export const CompetitionSearchNoResult = () => {
    return (
        <div className={style.noResult}>
            <div className={style.title}>Pas de résultat</div>
            <div className={style.subtitle}>
                Veuillez revenir plus tard ou modifier les critères de recherche.
            </div>
        </div>
    )
}
